import React, { useContext, useState, useEffect, useRef } from 'react';
import HeaderForm from './headerformnurse';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';

import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import secureLocalStorage from "react-secure-storage";
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";

import { useDispatch } from "react-redux";
import { AppContext } from '../context';
import newlogos from '../assets/img/logo-new-jsry.png';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { toast } from "react-toastify";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
function formdatechange(date, format = null) {
  const myArrayg = date.split(" ");
  var d = new Date(date);
  var wholedate = myArrayg[0];
  var alltime = myArrayg[1];
  const myArray = myArrayg[0].split("-");
  var month = myArray[1];
  var day = myArray[2];
  var year = myArray[0];


  var daten = (month + '/' + day + '/' + year) + ' ' + alltime;
  // if (month.length < 2) month = '0' + month;
  // if (day.length < 2) day = '0' + day;

  // if (format && format == 'Y-m-d') return [month, day, year].join('-');
  // else return [month, day, year].join('-');
  return daten;
}

function formdatechangeneew(date, format = null) {


  const myArray = date.split("-");
  var month = myArray[1];
  var day = myArray[2];
  var year = myArray[0];


  var daten = (month + '/' + day + '/' + year);

  return daten;
}
function userExists(arr, form_id) {
  return arr.some(function (el) {
    return el.form_id === form_id;
  });
}
function pdfExists(arr, document) {
  return arr.some(function (el) {
    return el.document === document;
  });
}
function ApplicationFormsUploaded() {

  const [openLog, setOpenLog] = React.useState(false);
  const handleCloselog = () => setOpenLog(true);

  const [opencheckLog, setOpenCheckLog] = React.useState(false);
  const handlecheckCloses = () => setOpenCheckLog(false);
  const handlecheckClose = () => setOpenCheckLog(true);
  const [manageapplicationList, setManagApplicationsList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loadernew, setLoaderNew] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [loaderId, setLoaderId] = useState('');
  const [searchType, setSearchType] = useState('employeeid');
  const [pageLoader, setPageLoader] = useState(false);
  const [loginval, setloginval] = useState(0);
  const { storage } = useContext(AppContext);
  //const [reason, setReason] = React.useState('');
  const [actionRow, setActionRow] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadErr, setUploadErr] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [submitErr, setSubmitErr] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [openIsUploaded, setOpenIsUploaded] = React.useState(false);
  const [isUploadedProcessing, setIsUploadedProcessing] = React.useState(false);
  const [isUploadedSuccess, setIsUploadedSuccess] = React.useState(null);
  const [isUploadedErr, setIsUploadedErr] = React.useState(null);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Student ID or Name');
  const [searchBy, setSearchBy] = useState('student_id');
  const [searchValue, setSearchValue] = useState('');
  const [checkUnderstand, setCheckUnderstand] = useState(false);
  const [ipuser, setIpuser] = useState(null);


  const [allDepartment, setAllDepartment] = useState([]);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [Viewuser, setuser] = useState(null);

  const [rejectLog, setRejectLog] = React.useState(false);
  const handlereject = () => {
    setRejectLog(true);
    setApproveLog(false);

  }
  const [openformsLog, setOpenformsLog] = React.useState(false);
  const handleFormsClose = () => setOpenformsLog(false);
  const handleFormsOpen = () => handleFormsOpen(true);
  const [formsdata, setformsdata] = useState(null);
  const handleFormStatusCheck = (useridnew) => {
    if (useridnew.pending_parent_form != 0) {
      setformsdata(useridnew);
      setOpenformsLog(true);
      setRejectLog(true);
      setRejectLog(false);
      setApproveLog(false);
      setReason('');
    } else {
      setActionRow(useridnew);
      setOpenCheckLog(true);
      setOpenformsLog(false);
      setRejectLog(false);
      setApproveLog(false);
      setReason('');
    }

  }


  const handleFormStatus = (item) => {
    setActionRow(item);
    setOpenCheckLog(true);
    setRejectLog(false);
    setOpenformsLog(false);
    setApproveLog(false);
    setReason('');
  }

  const [alldelete, setAlldelete] = useState(null);
  const [physicianDeleteId, setPhysicianDeleteId] = useState(null);
  const [openLogDelele, setOpenLogDelele] = React.useState(false);
  const handleDeleleClose = () => setOpenLogDelele(false);
  const handleDeleleOpen = () => setOpenLogDelele(true);
  const handleOpenDelete = (userid, id) => {
    setPhysicianDeleteId(id);
    setAlldelete(userid);
    setOpenLogDelele(true);
  }

  const handlesubmit = () => {
    if (submitting) return;
    setSubmitErr('');
    if (reason == '') {
      setSubmitErr('Please enter reason.');
      return false;
    }
    setSubmitting(true);
    Axios.post(`/application/update-status/${actionRow.id}`, {
      status: rejectLog ? 'Rejected' : 'Approved',
      reason: reason,
      nurseid: secureLocalStorage.getItem('nurseid')
    })
      .then(res => {
        if (res.data.status) {
          setSubmitSuccess(res.data.message);
          setTimeout(() => {
            setRejectLog(false);
            setApproveLog(false);
            setReason('');
            setOpenCheckLog(false);
            setSubmitSuccess('');
          }, 2000);
          loadApplications();
        } else {
          setSubmitErr(res.data.message);
        }
        setSubmitting(false);
      })
  }

  const [approveLog, setApproveLog] = React.useState(false);
  const handleapprove = () => {
    setApproveLog(true);
    setRejectLog(false);

  }


  useEffect(() => {
    axios.get("https://ipinfo.io/json")
      .then(res => {
        setIpuser(res.data.ip);
      }).catch(err => {

      })

  }, []);

  useEffect(() => {
    loadApplications();
  }, [pageNo, perPage, searchBy, searchValue]);

  const loadApplications = () => {
    setFirstLoading(true);
    var usernew = JSON.parse(secureLocalStorage.getItem('nursedata'));

    if (usernew == null || usernew == undefined) {
      navigate(`/stafflogin`);
    } else {
      setuser(usernew);

      Axios.post(`/application_list`, { location: usernew.location, "pageNo": pageNo, "perPage": perPage, search_by: searchBy, search: searchValue, is_approved: 1, type: usernew.type })
        .then(res => {
          setManagApplicationsList(res.data.data);
          setTotalCount(res.data.pagination.totalCount);
          setTotalPage(res.data.pagination.totalPage);
          setFirstLoading(false);
        });
    }


  }

  const handleReasonChange = (e) => {
    const { name, value } = e.target;
    setReason(value);
  }

  const handleDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/downloadforms/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `parent_consent_forms_${applItem.stuid}.zip`);
      })
  }
  const handleDownloadQuestioFile = (stuid) => {
    let applItem = getApplicationRow(stuid);

    Axios.get(`/nurse/question-form/${stuid}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `90_Days_Evaluation_Form_${stuid}.zip`);
      })
  }

  const handlePhysicianDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/application/download-physician-form/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `physician_forms_${applItem.stuid}.zip`);
      })
  }
  const handleDownloadFileconscent = (stuid, formid, pdfname) => {

    Axios.get(`/parent/download-form/${stuid}/${formid}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, pdfname);
      })
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }

  const handleDownload = (fileName) => {
    const link = document.createElement('a');
    link.href = storage[0].imageEndUrl + fileName;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleUploadDialog = (item) => {
    setActionRow(item);
    setOpenLog(true);
  }

  const getCurrentPendingPhysicianForms = () => {
    return 2 - actionRow.physician_document_details.length
  }

  const handleFileChange = (event) => {
    setUploadErr('');
    const files = Array.from(event.target.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    if (selectedFile.length + pdfFiles.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }
    setSelectedFile([...selectedFile, ...pdfFiles]);
  };

  const handleFileRemove = (index) => {
    const newFiles = [...selectedFile];
    newFiles.splice(index, 1);
    setSelectedFile(newFiles);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setUploadErr('');
    const files = Array.from(event.dataTransfer.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    if (selectedFile.length + pdfFiles.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }
    setSelectedFile([...selectedFile, ...pdfFiles]);
  };

  const handleUpload = () => {
    if (uploading) return;
    setUploadErr('');

    if (selectedFile.length < getCurrentPendingPhysicianForms()) {
      setUploadErr('Please select physician file to upload.');
      return;
    }
    if (selectedFile.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }

    setUploading(true);
    const formData = new FormData();
    selectedFile.forEach((file, i) => {
      formData.append(`files[${i}]`, file);
    });
    formData.append('ip_address', ipuser);

    Axios.post(`/application/upload-physician-form/${actionRow.id}`, formData)
      .then(res => {
        if (res.data.status) {
          setUploadSuccess(res.data.message);
          setTimeout(() => {
            setSelectedFile([]);
            setOpenLog(false);
            setUploadSuccess('');
          }, 2000);
          loadApplications();
        } else {
          setUploadErr(res.data.message);
        }
        setUploading(false);
      })
  }

  const getApplicationRow = (id) => {
    return manageapplicationList.find(item => item.id == id);
  }

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  }

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);

  };

  const changePage = (page) => {
    var usernew = JSON.parse(secureLocalStorage.getItem('nursedata'));
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setFirstLoading(true);
    setPageNo(page);

  }

  const handlePhycianDelte = () => {
    if (uploading) return;
    setUploadErr('');

    setUploading(true);

    Axios.post(`/physician_file_delete/`, { id: physicianDeleteId, consent_form_id: alldelete })
      .then(res => {
        if (res.data.status) {
          setUploadSuccess('Physician Form Deleted Successfully');
          loadApplications();
          setTimeout(() => {
            setPhysicianDeleteId(null);
            setAlldelete(null);
            setOpenLogDelele(false);
            setUploadSuccess('');
          }, 2000);

        } else {
          setUploadErr('Error');
        }
        setUploading(false);
      })
  }



  const handleIsUploaded = (e, useridnew) => {
    e.preventDefault();

    if (useridnew.is_uploaded) return;

  }

  const isUploadedClose = () => {
    setOpenIsUploaded(false);
  }

  const handleIsUploadConfirm = () => {
    if (isUploadedProcessing) return;
    setIsUploadedErr('');
    setIsUploadedProcessing(true);
    Axios.post(`/application/update-uploaded/${formsdata.id}`)
      .then(res => {
        if (res.data.status) {
          setIsUploadedSuccess(res.data.message);
          loadApplications();
          setTimeout(() => {
            isUploadedClose();
            setIsUploadedSuccess('');
          }, 2000);

        } else {
          setIsUploadedErr(res.data.message);
        }
        setIsUploadedProcessing(false);
      })
  }

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    setPageNo(1);
  }

  const handleColumnClick = (type) => {
    let placeholder = '';
    switch (type) {
      case 'location':
        placeholder = 'Location';
        break;
      case 'student_id':
        placeholder = 'Student ID or Name';
        break;
      case 'student_name':
        placeholder = 'Student Name';
        break;
      case 'grade':
        placeholder = 'Grade';
        break;
      default:
        placeholder = 'Location';
        break;
    }
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
    setPageNo(1);
  }

  const handleChangeUnderstand = (e) => {
    setCheckUnderstand(e.target.checked);
  }

  const [reason, setReason] = React.useState(false)
  const [reasondeatils, setReasonDeatils] = React.useState('');
  const handlereason = (consent_form) => {
    setReasonDeatils(consent_form);
    setReason(true);
  }
  const handleCloselogss = () => setReason(false);


  const [consentreason, setConsentReason] = React.useState(false)
  const [reasonconsentdeatils, setReasonConsentDeatils] = React.useState('');
  const handlereasonconsent = (first_consent_form) => {
    setReasonConsentDeatils(first_consent_form);
    setConsentReason(true);
  }
  const handleCloselogssconse = () => setConsentReason(false);

  const [reasondeatilscl, setReasonDeatilscl] = React.useState('');
  const [reasoncl, setReasoncl] = React.useState(false)
  const handlelear = (consent_form) => {
    setReasonDeatilscl(consent_form);
    setReasoncl(true);
  }
  const handleCloselogsscl = () => setReasoncl(false);
  const handlePhycianDeltecl = () => {
    if (uploading) return;
    setUploadErr('');

    setUploading(true);

    Axios.post(`/physician_status_delete/`, { consent_form_id: reasondeatilscl.id, nurseid: secureLocalStorage.getItem('nurseid') })
      .then(res => {
        if (res.data.status) {
          setUploadSuccess('Form Reinstate Successfully');
          loadApplications();
          setTimeout(() => {
            setPhysicianDeleteId(null);
            setAlldelete(null);
            setReasoncl(false);
            setUploadSuccess('');
          }, 2000);

        } else {
          setUploadErr('Error');
        }
        setUploading(false);
      })
  }
  return (
    <>
      <HeaderForm />
      <div className='regis-main-sec forms-main-sec'>
        <div className='container-fluid'>

          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head forms-heading-sec'>
                <h2 className={`${(Viewuser && Viewuser.type == 'C') ? 'c-app-sat' : ''}`}>Application Status Listing</h2>

                {/* <Link to="/applicationstatus"> <p className='stts-sec  go-frm-cols go-new-add '>VIEW APPLICATION STATUS</p>

                  <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                    <div class="scroll-prompt-arrow-container new-go-spp">
                      <div class="scroll-prompt-arrow"><div></div></div>
                      <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                    </div>
                  </div>
                </Link>*/ }

                {
                  Viewuser && Viewuser.type == 'N' &&
                  <Link to="/application"> <p className='stts-sec  go-frm-cols go-new-add '>VIEW APPLICATION LIST</p>

                    <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                      <div class="scroll-prompt-arrow-container new-go-spp">
                        <div class="scroll-prompt-arrow"><div></div></div>
                        <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                      </div>
                    </div>
                  </Link>
                }

              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row'>
                      {
                        Viewuser && Viewuser.type == 'C' &&
                        <div className='col-md-12 margin-ns-pad'>
                          <div className='indicate-secss'>

                            <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-yellow'><span className='new-roud-val'>P</span></span><span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#f19103', fontWeight: '700' }}>Pending</span></p>
                            <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-green'><span className='new-roud-val'>A</span></span> <span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#059652', fontWeight: '700' }}>Approved</span></p>
                            <p className='style-new-ntk'><span className='square-sec-redsss '><span className='new-round-redss'><span className='new-roud-val'>R</span></span><span className='dash-sec-nwe'> - </span></span><span style={{ color: '#fb0b0b', fontWeight: '700' }}>Rejected</span></p>

                          </div>

                        </div>
                      }
                    </div>
                    <div className='row'>

                      <div className='col-md-12' style={{ visibility: (Viewuser && Viewuser.type == 'N') ? "inherit" : "hidden" }} >
                        <div className='indicate-secss'>


                          <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-green'><span className='new-roud-val'>A</span></span> <span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#059652', fontWeight: '700' }}>Approved</span></p>
                          <p className='style-new-ntk'><span className='square-sec-redsss '><span className='new-round-redss'><span className='new-roud-val'>R</span></span><span className='dash-sec-nwe'> - </span></span><span style={{ color: '#fb0b0b', fontWeight: '700' }}>Rejected</span></p>

                        </div>

                      </div>


                      <div className="col-sm-3"  >
                        <div className="sorting-e-form " style={{ marginTop: (Viewuser && Viewuser.type == 'N') ? "-50px" : "-25px" }}>
                          <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' onChange={perPageChange} value={perPage}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                          </label>
                        </div>
                      </div>


                      {
                        Viewuser && Viewuser.type == 'N' &&

                        <div className="col-md-6 margin-ns-pad">

                          {manageapplicationList.length > 0 ?
                            <p className="total-user right-user tot-app" style={{ marginTop: (Viewuser && Viewuser.type == 'N') ? "-55px" : "-50px" }}>Total Applications {totalCount}</p>
                            : null}

                          <div className='filtr-sec'>
                            <div className='select-sec-newss' >
                              <select>
                                <option>Liberty High School</option>
                                <option>Liberty High School</option>
                                <option>Liberty High School</option>
                              </select>
                            </div>
                            {
                              Viewuser && Viewuser.type == 'N' &&
                              <div className={`text-fld-sec appl_status_list new-text-ggg ${(Viewuser && Viewuser.type == 'C') ? 'appl_status_listnc' : ''}`}>
                                <input type="text" placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} className='inpt-sec' />
                                <span className='search-sec'><SearchIcon /></span>
                              </div>
                            }



                          </div>


                        </div>
                      }


                      {
                        Viewuser && Viewuser.type == 'C' &&
                        <>
                          <div className="col-md-6 margin-ns-pad">

                            {manageapplicationList.length > 0 ?
                              <p className="total-user right-user tot-app" style={{ marginTop: (Viewuser && Viewuser.type == 'N') ? "-55px" : "-50px" }}>Total Applications {totalCount}</p>
                              : null}




                          </div>
                          <div className="col-md-3 margin-ns-pad">
                            <div className='filtr-sec'>
                              <div className='select-sec-newss' >
                                <select>
                                  <option>Liberty High School</option>
                                  <option>Liberty High School</option>
                                  <option>Liberty High School</option>
                                </select>
                              </div>
                             
                                <div className={`text-fld-sec  new-text-ggg appl_status_list_new-co  `}>
                                  <input type="text" placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} className='inpt-sec' />
                                  <span className='search-sec'><SearchIcon /></span>
                                </div>
                              



                            </div>
                          </div>
                        </>
                      }

                      {/* <div className='col-md-3'>

                      </div> */}
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table className="table table-bordered">
                          <thead className="thead-light thead-travel thead-form">
                            <tr>
                              <th className='std-id-width' onClick={() => handleColumnClick('student_id')} role='button'>Student ID <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='loc-width' onClick={() => handleColumnClick('location')} role='button'>Location <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='std-name-width' onClick={() => handleColumnClick('student_name')} role='button'>Student Name <span className='fitr-sec-nw'><FilterListIcon /></span></th>

                              {
                                Viewuser && Viewuser.type == 'C' &&
                                <th className='date-width'>Consent Form</th>
                              }


                              {/* <th className='date-width'>Parent Consent Form</th>
                              <th className='date-width'>Physician Form</th> */}
                              <th className='grade-width' >Updated By</th>
                              {
                                Viewuser && Viewuser.type == 'N' &&
                                <th className='date-width'>90 Days <br></br>Evaluation Form</th>
                              }
                              <th className='stts-width'>Status</th>
                              <th className='stts-width'>Feedback</th>
                              {/* <th className='action-width'>Action</th> */}
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            {
                              firstLoading ? <tr ><td colSpan={8}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                                {manageapplicationList.length > 0 ?

                                  manageapplicationList.map((userd, index) =>
                                    <tr key={index}>
                                      <td className='std-id'>{userd.stuid}</td>
                                      <td>
                                        {userd.school_name}
                                      </td>
                                      <td>{userd.student_name} {userd.last_name}</td>

                                      {
                                        Viewuser && Viewuser.type == 'C' &&
                                        <td>
                                          {userd.first_consent_form != null &&

                                            <div className='stst-visi'>
                                              <span className='visib-sec view-new-fmr'
                                                onClick={() => handlereasonconsent(userd.first_consent_form)}

                                              >View Form</span></div>

                                          }


                                        </td>

                                      }

                                      {/* <td><p className='form-comp'>

                                        {
                                          Viewuser && Viewuser.type == 'N' &&
                                          <>
                                            {userd.document_details.length > 0 && userd.document_details.length}
                                            <span className={` ${(userd.pending_parent_form != 0) && 'red-down'} ${(userd.pending_parent_form == 0) && 'blue-down'}`}>
                                              <a title="Download"><DownloadIcon onClick={() => handleDownloadFile(userd.id)} /></a></span>
                                          </>

                                        }
                                      </p>
                                        {
                                          userd.pending_parent_form != 0 ? <p className='form-pend'>{userd.pending_parent_form} Form Pending</p> : <>
                                            {
                                              Viewuser && Viewuser.type == 'C' &&
                                              <p className='form-uploaded'> {userd.document_details.length} Forms Uploaded</p>
                                            }
                                          </>
                                        }
                                      </td>
                                      <td>
                                        {
                                          Viewuser && Viewuser.type == 'N' ?
                                            <>
                                              {
                                                userd.physician_document_details.length ?
                                                  <div>
                                                    <ul className='list-group'>

                                                      {
                                                        userd.physician_document_details.map((item, index2) => (
                                                          <li className='list-group-item psycn-form-link' key={index2}>

                                                            <span className="blue-down">
                                                              <a title="Download" ><DownloadIcon className='download_icon' onClick={() => handleDownload(item.document)} />
                                                              </a></span>

                                                            {truncateString(item.document, 35)}
                                                            
                                                          </li>
                                                        ))
                                                      }

                                                    </ul>
                                                  </div> : null
                                              }
                                            </>
                                            :
                                            <>
                                              {userd.physician_document_details.length > 0 &&
                                                <>

                                                  <p className={` ${(userd.physician_document_details.length == 2) && 'form-uploaded'} ${(userd.physician_document_details.length == 1) && 'form-pend'}`}> {userd.physician_document_details.length} Physician {(userd.physician_document_details.length == 2) && 'Forms'} {(userd.physician_document_details.length == 1) && 'Form'} Uploaded</p>


                                                </>
                                              }
                                            </>
                                        }
                                      </td> */}
                                      <td>
                                        {userd.nurse_details != null && <>
                                          {userd.nurse_details.name} {userd.nurse_details.last_name}

                                        </>}

                                      </td>
                                      {
                                        Viewuser && Viewuser.type == 'N' &&
                                        <td>


                                          <p className='form-comp'>
                                            {userd.questionnaire_document_details.length > 0 ?
                                              <>
                                                {userd.questionnaire_document_details.length}
                                                <span className={` blue-down`}>
                                                  <a title="Download"><DownloadIcon onClick={() => handleDownloadQuestioFile(userd.stuid)} /></a></span>


                                              </>
                                              :
                                              <>
                                                <span className={`green-down `}>


                                                  {(userd.consent_details.status == 'Approved') &&
                                                    <>{
                                                      (userd.consent_details.mail_sent != null) &&
                                                      <>Due On : {formdatechangeneew(userd.consent_details.mail_sent)}

                                                      </>
                                                    }  </>}
                                                </span>
                                              </>
                                            }


                                          </p>
                                        </td>
                                      }
                                      {/*<td className='std-id' onClick={() => handleFormStatusCheck(userd)}><CheckIcon /></td>*/}
                                      <td>
                                        <div className='round-stss'>

                                          <span className=
                                            {`green-down ${(userd.consent_details.status == 'Rejected') ? 'square-sec-redss new-round-red' : (userd.consent_details.status == 'Pending' ? 'pend-sts round-pend' : 'round-approve')}`} style={{ fontWeight: '700', fontSize: '17px' }}>
                                            {(userd.consent_details.status == 'Rejected') && 'R'}
                                            {(userd.consent_details.status == 'Pending') && 'P'}
                                            {(userd.consent_details.status == 'Approved') && 'A'}</span>


                                          {
                                            (Viewuser && Viewuser.type == 'N' && userd.consent_details.status == 'Rejected') &&
                                            <div className='stst-visi'>
                                              <span className='visib-sec'
                                              >  <ClearIcon onClick={() => handlelear(userd.consent_details)} style={{ color: '#fb0b0b' }} /></span>
                                            </div>
                                          }
                                        </div>
                                      </td>
                                      <td>
                                        <div className='round-stss'>


                                          {(userd.consent_details.status == 'Approved' || userd.consent_details.status == 'Rejected') &&
                                            <>
                                              {userd.consent_details.reason != '' && userd.consent_details.reason != null &&
                                                <div className='stst-visi'>
                                                  <span className='visib-sec'
                                                    onClick={() => handlereason(userd.consent_details)}><VisibilityIcon /></span></div>

                                              }
                                            </>
                                          }
                                          {
                                            (Viewuser && Viewuser.type == 'N' && userd.consent_details.status == 'Rejected') &&
                                            <div className='stst-visi'>
                                              <span className='visib-sec'
                                              >  <ClearIcon onClick={() => handlelear(userd.consent_details)} style={{ color: '#fb0b0b' }} /></span>
                                            </div>
                                          }
                                        </div>
                                      </td>
                                      {/* <td className='action-sec'><Link to="/applicationdetails"><VisibilityIcon /></Link></td> */}
                                    </tr>
                                  )

                                  : <tr><td colSpan={8}>No Data Found</td></tr>}
                              </>
                            }

                          </tbody>
                        </table>
                        {/* pagination code start  */}

                        {totalPage > 1 ? <>
                          <div className="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                            <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                              <div className="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                                <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {pageNo} of {totalPage}</p>
                              </div>
                              <div className="pagin-sec">
                                <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={(e) => changePage(pageNo - 1)}></i>
                                <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#626262" }}>Go to </span>
                                <input type="number"
                                  value={pageNo} onChange={(e) => {
                                    !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                  }}
                                  style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "8px 6px 0px 4px", fontSize: "14px", width: "34px", height: '34px', float: "left", height: "22px", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }} />

                                <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={(e) => changePage(pageNo + 1)}></i>
                              </div>
                            </div>

                          </div>
                        </> : ''
                        }

                        {/* pagination code end */}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* modal section for status start */}

      <BootstrapDialog
        onClose={handlecheckClose}
        aria-labelledby="customized-dialog-title"
        open={opencheckLog} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handlecheckCloses}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec ${approveLog ? 'sectionhide' : ''}`} style={{ display: rejectLog ? 'none' : 'block' }}>
              <h2>This application requires an Action</h2>
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={handleapprove}>Approve </button>
                <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handlereject}>Reject </button>
              </div>
            </div>

            <div className='reject-sec logout-sec-modal' style={{ display: rejectLog ? 'block' : 'none' }}>
              <h2 style={{ marginBottom: '20px' }}>Reason for Rejection</h2>
              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50" name="reject" onChange={handleReasonChange} value={reason} />
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms" onClick={handlesubmit} type="button">
                  {
                    submitting ?
                      <>
                        Submit <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Submit
                      </>
                  }
                </button>
              </div>
              {
                submitSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{submitSuccess}</p>
                  </div>
                  : null
              }
              {
                submitErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{submitErr}</p>
                  </div>
                  : null
              }
            </div>

            <div className='reject-sec logout-sec-modal' style={{ display: approveLog ? 'block' : 'none' }}>
              <h2 style={{ marginBottom: '20px' }}>Your Feedback</h2>
              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50" name="reject" onChange={handleReasonChange} value={reason} />
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms" onClick={handlesubmit} type="button">
                  {
                    submitting ?
                      <>
                        Submit <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Submit
                      </>
                  }
                </button>
              </div>
              {
                submitSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{submitSuccess}</p>
                  </div>
                  : null
              }
              {
                submitErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{submitErr}</p>
                  </div>
                  : null
              }
            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleFormsClose}
        aria-labelledby="customized-dialog-title"
        open={openformsLog} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleFormsClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >
              {formsdata != null ?
                <>
                  <h2>{formsdata.pending_parent_form} forms pending, do you want to still proceed?</h2>
                </>

                :
                ''}

              <div className='button-sec-app'>
                {formsdata != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handleFormStatus(formsdata)}>Yes </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleFormsClose}>No </button>

                  </>

                  :
                  ''}

              </div>
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={isUploadedClose}
        aria-labelledby="customized-dialog-title"
        open={openIsUploaded} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={isUploadedClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >
              <div className='check-sec modal-check-sec'>
                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '8px' }}>
                    {
                      formsdata != null ?
                        <>
                          {
                            formsdata.pending_parent_form != 0 ?
                              <p className="para-fill">This application has pending forms, do you want to mark it as completed?</p>
                              :
                              <p className="para-fill">You are marking this application as completed</p>
                          }
                        </>
                        : null
                    }
                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>
                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I understand" control={<Checkbox />}
                          checked={checkUnderstand} onChange={handleChangeUnderstand} />
                      </FormGroup>
                      <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                        disabled={checkUnderstand == false ? 'disabled' : false} onClick={handleIsUploadConfirm}>
                        {
                          isUploadedProcessing ?
                            <>
                              PROCEED <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </>
                            :
                            <>
                              PROCEED
                            </>
                        }
                      </button>
                    </div>
                  </div>
                  <div className='col-md-12' style={{ marginBottom: '10px' }}>
                    {
                      isUploadedSuccess ?
                        <div className="success-msg success-login success-new-msg">
                          <p className="success-msg success-login" >{isUploadedSuccess}</p>
                        </div>
                        : null
                    }
                    {
                      isUploadedErr ?
                        <div className="error-msg error-login" >
                          <p className="error-msg error-login">{isUploadedErr}</p>
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </DialogContent>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleDeleleClose}
        aria-labelledby="customized-dialog-title"
        open={openLogDelele} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleDeleleClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >

              <h2>Do you want to delete this Physician Form?</h2>


              <div className='button-sec-app'>
                {alldelete != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handlePhycianDelte()}> {
                      uploading ?
                        <>
                          Yes <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </>
                        :
                        <>
                          Yes
                        </>
                    } </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleDeleleClose}>No </button>

                  </>

                  :
                  ''}

              </div>
              {
                uploadSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{uploadSuccess}</p>
                  </div>
                  : null
              }
              {
                uploadErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{uploadErr}</p>
                  </div>
                  : null
              }
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleCloselogss}
        aria-labelledby="customized-dialog-title"
        open={reason} className="route-view copy-view logout-view login-modal app-modal resn-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}>
              {reasondeatils != null && reasondeatils != '' &&
                <>
                  {
                    reasondeatils.status == 'Approved' ?
                      <h2 className='uplod-secddd'>Approval Feedback</h2>
                      :
                      <h2 className='uplod-secddd'>Reason For Rejection</h2>
                  }
                  <p className='uplod-para approv-fed'>{reasondeatils.reason}</p>
                </>
              }

            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>



      <BootstrapDialog
        onClose={handleCloselogsscl}
        aria-labelledby="customized-dialog-title"
        open={reasoncl} className="route-view copy-view logout-view login-modal app-modal resn-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogsscl}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >

              <h2>Would you like to reinstate the application ?</h2>


              <div className='button-sec-app'>
                {reasondeatilscl != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handlePhycianDeltecl()}> {
                      uploading ?
                        <>
                          Yes <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </>
                        :
                        <>
                          Yes
                        </>
                    } </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleCloselogsscl}>No </button>

                  </>

                  :
                  ''}

              </div>
              {
                uploadSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{uploadSuccess}</p>
                  </div>
                  : null
              }
              {
                uploadErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{uploadErr}</p>
                  </div>
                  : null
              }
            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleCloselogssconse}
        aria-labelledby="customized-dialog-title"
        open={consentreason} className="route-view copy-view logout-view login-modal app-modal action-modl new-apps-sec">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogssconse}>

        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>

            {(reasonconsentdeatils != null) &&
              <>
                <div style={{ width: '100%', fontFamily: 'arial', fontSize: '15px' }}>
                  <div>
                    <p style={{ textAlign: 'right', position: 'relative', lineHeight: '19px', fontSize: '13px' }}>
                      346 Claremont <br /> Ave Jersey City, NJ 07305
                    </p>
                  </div>
                  <table style={{ width: '100%', fontFamily: 'arial', fontSize: '15px', borderCollapse: 'collapse' }}>
                    <thead style={{ fontSize: '16px', fontWeight: 'bold', padding: '1px 8px 0px !important', textAlign: 'center', width: '100%', color: '#000', marginBottom: '0px', border: '0px', borderTop: '4px solid #FF9800', textTransform: 'uppercase', backgroundColor: '#e4e4e4' }}>
                      <tr><th style={{ padding: '20px 10px', width: '20%' }}>
                        <img src={newlogos} style={{ height: '50px', float: 'left', position: 'relative', top: '0px' }} />
                        <div>
                          <a style={{ fontSize: '13px' }}>Jersey City Public Schools Department of Athletics</a><br />
                          <a style={{ marginTop: '7px', display: 'block', fontSize: '13px' }}>CONSENT FORM FOR INTERSCHOLASTIC
                            ATHLETICS
                          </a>
                        </div>
                        <div>
                          {/* <p style={{ textAlign: 'right', position: 'absolute', right: '42px', top: '5px', lineHeight: '19px', fontSize: '11px' }}>
                            346 Claremont <br /> Ave Jersey City, NJ 07305
                          </p> */}
                        </div>
                      </th>
                      </tr></thead>
                    <tbody>
                      <tr>
                        <td style={{ border: '0px', padding: '10px 20px 10px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                          <table style={{ width: '100%' }}>
                            <tbody>
                              <tr>
                                <td style={{ width: '100px', fontSize: '15px', fontWeight: 500, padding: '2px 0px', textAlign: 'left', lineHeight: '23px' }}>
                                  <p style={{ fontStyle: 'italic', margin: '10px 0px 10px 0px' }}>With my full knowledge
                                    and consent <span style={{ fontWeight: 600 }}>{reasonconsentdeatils.consent}</span> may participate in all physical activities and may take trips that are part
                                    of this program.</p>
                                  <p style={{ fontStyle: 'italic' }}>The school authorities will exercise maximum care
                                    in the administration and control of athletic activities in order to
                                    safeguard participants against injury and accident.</p>
                                  <p style={{ fontStyle: 'italic' }}>Realizing that such activity involves the
                                    potential for injury, which is inherent in all sports, I/we acknowledge that
                                    even with the best coaching, use of the most advanced protective equipment
                                    and strict observances of the rules, injuries are still a possibility. On
                                    rare occasions these injures can be so severe as to result in total
                                    disability, paralysis, or even death.
                                    I/we acknowledge that I/we have read and understand this warning.</p>
                                  <p style={{ fontStyle: 'italic' }}>In the event of an injury to my child I give
                                    consent as parent/guardian to have my child assessed and treated by a
                                    certified Athletic Trainer. I also give my permission for disclosure of
                                    medical information regarding my child and any treatment necessary in the
                                    event of a medical emergency.</p>
                                  <p style={{ fontStyle: 'italic' }}>I certify that the information provided herein is
                                    accurate as of the date of these signatures.</p>
                                </td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      {/* signature section start */}
                      <tr>
                        <td>
                          <table classname style={{ width: '100%' }}>
                            <tbody>
                              <tr>
                                <td style={{ border: '0px', padding: '5px 10px 5px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '70%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left', width: '45%',verticalAlign: 'baseline' }}>
                                                  Parent/Guardian (Signature): </td>
                                                <td className="signature" style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '35%', fontFamily: 'Satisfy', fontWeight: 'normal', fontStyle: 'normal' }}>
                                                  {reasonconsentdeatils.parent_signature}

                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                        <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '30%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ width: '20%', fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left' }}>
                                                  Date: </td>
                                                <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '52%' }}>
                                                  {(reasonconsentdeatils.first_form_date != null) &&

                                                    formdatechangeneew(reasonconsentdeatils.first_form_date)}


                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>

                                    </tbody>
                                  </table>
                                </td>
                              </tr>


                              <tr>
                                <td style={{ border: '0px', padding: '5px 10px 5px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left', width: '27%', verticalAlign: 'baseline' }}>
                                                  Parent/Guardian (Print Name): </td>
                                                <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '43%', verticalAlign: 'baseline' }}>
                                                  {reasonconsentdeatils.parent_name}

                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>



                              <tr>
                                <td style={{ border: '0px', padding: '5px 10px 5px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '70%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left', width: '45%',verticalAlign: 'baseline'  }}>
                                                  Student (Signature): </td>
                                                <td className="signature" style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '37%', fontFamily: 'Satisfy', fontWeight: 'normal', fontStyle: 'normal' }}>

                                                  {reasonconsentdeatils.student_signature}


                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                        <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '30%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ width: '20%', fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left' }}>
                                                  Date: </td>
                                                <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '52%' }}>
                                                  {(reasonconsentdeatils.first_form_date != null) &&

                                                    formdatechangeneew(reasonconsentdeatils.first_form_date)}

                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>

                                    </tbody>
                                  </table>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ border: '0px', padding: '5px 10px 5px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left', width: '27%', verticalAlign: 'baseline' }}>
                                                  Student (Print Name):</td>
                                                <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '43%', verticalAlign: 'baseline' }}>
                                                  {reasonconsentdeatils.student_name}

                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ border: '0px', padding: '5px 10px 5px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                    </tbody>
                                    <tr>
                                      <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                                        <table style={{ width: '100%' }}>
                                          <tbody>
                                            <tr>
                                              <td style={{ fontSize: '15px', fontWeight: 700, padding: '4px 0px', textAlign: 'left', width: '5%', verticalAlign: 'baseline' }}>
                                                Address:</td>
                                              <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '53%', verticalAlign: 'baseline' }}>
                                                {reasonconsentdeatils.address}

                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>


                            </tbody>
                          </table>
                        </td>
                      </tr>
                      {/* signatur section end */}
                      {/* other section start */}
                      <tr>
                        <td>
                          <table classname style={{ width: '100%', marginTop: '0px' }}>
                            <tbody>
                              <tr>
                                <td style={{ border: '0px', padding: '0px 10px 6px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                  <table style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2} style={{ border: '0px', padding: '5px 2px 0px 2px', fontSize: '12px', textAlign: 'left' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ width: '10%', fontSize: '16px', fontWeight: 700, padding: '5px 0px', textAlign: 'left' }}>
                                                  Emergency Phone Numbers </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table classname style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: '0px', padding: '0px 10px 0px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left', width: '40%' }}>
                                                          Primary#: </td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '60%' }}>
                                                          {reasonconsentdeatils.primary_em}


                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left', width: '40%' }}>
                                                          Relationship: </td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '60%' }}>
                                                          {reasonconsentdeatils.relationship_primary}

                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left', width: '40%' }}>
                                                          Secondary#: </td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '60%' }}>
                                                          {reasonconsentdeatils.secondary_em}



                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left', width: '40%' }}>
                                                          Relationship: </td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '60%' }}>
                                                          {reasonconsentdeatils.relationship_secondary}

                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table classname style={{ width: '100%', marginTop: '10px' }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: '0px', padding: '0px 2px 6px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 0px', fontSize: '12px', textAlign: 'left' }}>
                                                  <table style={{ width: '100%', backgroundColor: '#00BCD4', padding: '15px 6px', color: '#ffffff', fontSize: '18px' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ width: '9%', fontSize: '16px', fontWeight: 700, padding: '10px 15px 10px 15px', textAlign: 'left', lineHeight: '22px' }}>
                                                          Physician Information </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table classname style={{ width: '100%' }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: '0px', padding: '2px 10px 0px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ width: '16%', fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left' }}>
                                                          Name: </td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '65%' }}>
                                                          {reasonconsentdeatils.physican_name}

                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left', width: '50%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ width: '35%', fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left' }}>
                                                          Phone Number: </td>

                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '50%' }}>
                                                          {reasonconsentdeatils.physican_phone}

                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              {/* <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '10px 2px 0px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ width: '50%', fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left' }}>
                                                          Address:</td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'middle !important', width: '50%' }}>
                                                          {reasonconsentdeatils.physican_address}


                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr> */}
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: '0px', padding: '2px 10px 10px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td style={{ border: '0px', padding: '0px 2px 0px', fontSize: '12px', textAlign: 'left', width: '100%' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ width: '3%', fontSize: '15px', fontWeight: 700, padding: '5px 0px', textAlign: 'left', verticalAlign: 'baseline', }}>
                                                          Address:</td>
                                                        <td style={{ fontSize: '14px', color: '#303030', textAlign: 'left !important', verticalAlign: 'baseline', width: '52%' }}>
                                                          {reasonconsentdeatils.physican_address}


                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>



                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <table classname style={{ width: '100%', marginTop: '5px' }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: '0px', padding: '0px 10px 6px', fontSize: '12px', textAlign: 'left', width: '10%' }}>
                                          <table style={{ width: '100%' }}>
                                            <tbody>
                                              <tr>
                                                <td colSpan={2} style={{ border: '0px', padding: '0px 2px', fontSize: '12px', textAlign: 'left' }}>
                                                  <table style={{ width: '100%' }}>
                                                    <tbody>
                                                      <tr>
                                                        {/* <td style={{ width: '100%', fontSize: '15px', fontWeight: 700, padding: '2px 0px', textAlign: 'left' }}>
                                                          <input type="checkbox" name="physi" style={{ position: 'relative', top: '5px' }}
                                                            
                                                        checked={(reasonconsentdeatils.no_physican == 1) ? true : false}
                                                      
                                                          />

                                                          <span> I DO NOT HAVE A PHYSICIAN</span>
                                                        </td> */}
                                                        <td>
                                                          <FormGroup className='radio-sec'>
                                                            <FormControlLabel label=" I DO NOT HAVE A PHYSICIAN" control={<Checkbox />}
                                                              checked={(reasonconsentdeatils.no_physican == 1) ? true : false} />
                                                          </FormGroup>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td></tr></tbody></table></div>
              </>

            }






          </Typography>
        </DialogContent>
      </BootstrapDialog>
      {/* modal section end */}



    </>
  )
}
export default ApplicationFormsUploaded;
